import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Message, Spin } from "@/frontend/components/common";
import { bettingPoolService } from "@/frontend/services";
import { BettingPoolForm } from "./BettingPoolForm";
import type { BettingPoolWithTournamentResponseDTO } from "@/shared/dto";
import { useAuthStore } from "@/frontend/stores";

export function EditBettingPoolPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [poolData, setPoolData] = useState<BettingPoolWithTournamentResponseDTO | null>(null);

  useEffect(() => {
    const loadPool = async () => {
      if (!id) {
        Message.error({ content: "ID de pool no proporcionado" });
        navigate("/sports-predictions/pools/my-pools");
        return;
      }

      try {
        setLoading(true);
        const response = await bettingPoolService.getByIdWithTournament(id);

        if (response.success && response.data) {
          const poolWithTournament = response.data;
          setPoolData(poolWithTournament);

          if (!user?.id || poolWithTournament.creatorId !== user.id) {
            Message.error({
              content: "Solo el creador del pool puede editarlo",
            });
            navigate(`/sports-predictions/pools/${id}`);
            return;
          }
        } else {
          Message.error({
            content: response.error || "Error al cargar el pool",
          });
          navigate("/sports-predictions/pools/my-pools");
        }
      } catch (error) {
        Message.error({
          content:
            error instanceof Error ? error.message : "Error al cargar el pool",
        });
        navigate("/sports-predictions/pools/my-pools");
      } finally {
        setLoading(false);
      }
    };

    loadPool();
  }, [id, navigate, user]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  if (!poolData) {
    return null;
  }

  return (
    <BettingPoolForm 
      mode="edit" 
      existingPool={poolData} 
      existingTournament={poolData.tournament} 
    />
  );
}
